import { useQuery } from '@tanstack/react-query';
import { getClientById } from './clients-api';
import { client } from '../constants/urls';
import type { Client } from './interfaces';

/** Basic client info (name + last name) for the given client. Cached for the session. */
export const useClient = (clientId: string) =>
  useQuery<Client>({
    queryKey: [client, clientId],
    queryFn: () => getClientById(clientId),
    enabled: !!clientId,
    staleTime: Infinity,
  });
